if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (!event.detail.currentElement || !this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = Array.from(this.elements.viewer.querySelectorAll('[id^="Slide-"][data-media-id]'))
        .find((slide) => slide.dataset.mediaId === String(mediaId));
      // Never deactivate the current photo for a stale or nested modal-button ID.
      if (!activeMedia || activeMedia.hidden) return;
      this.elements.viewer.querySelectorAll('[id^="Slide-"][data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* Lise Luxury: bounded previous/next controls for product media.
   Controls never wrap: at the first/last visible image the unavailable arrow is disabled. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || viewer.querySelectorAll('[id^="Slide-"][data-media-id]').length < 2 || gallery.querySelector('.lise-gallery-arrows')) return;
    const controls = document.createElement('div');
    controls.className = 'lise-gallery-arrows';
    controls.innerHTML = '<button type="button" class="lise-gallery-arrow lise-gallery-arrow--prev" aria-label="Previous image">‹</button><button type="button" class="lise-gallery-arrow lise-gallery-arrow--next" aria-label="Next image">›</button>';
    gallery.appendChild(controls);
    const prev = controls.querySelector('.lise-gallery-arrow--prev');
    const next = controls.querySelector('.lise-gallery-arrow--next');
    const state = () => {
      // Inactive desktop slides use display:none; they still belong in navigation.
      // Nested modal buttons also carry data-media-id, but are never gallery slides.
      const candidates = [...viewer.querySelectorAll('[id^="Slide-"][data-media-id]')];
      const firstVariant = candidates.find(x => x.classList.contains('product__media-item--variant'));
      const slides = candidates.filter(x => !x.hidden &&
        (!x.classList.contains('product__media-item--variant') || x === firstVariant || x.classList.contains('is-active')));
      let i = slides.findIndex(x => x.classList.contains('is-active'));
      if (i < 0) i = 0;
      prev.disabled = slides.length < 2 || i <= 0;
      next.disabled = slides.length < 2 || i >= slides.length - 1;
      prev.setAttribute('aria-disabled', String(prev.disabled));
      next.setAttribute('aria-disabled', String(next.disabled));
      return { slides, i };
    };
    const move = (dir) => {
      const { slides, i } = state();
      const targetIndex = i + dir;
      if (targetIndex < 0 || targetIndex >= slides.length) return;
      if (typeof gallery.setActiveMedia !== 'function') return;
      gallery.setActiveMedia(slides[targetIndex].dataset.mediaId, false);
      requestAnimationFrame(state);
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewer.addEventListener('scroll', () => requestAnimationFrame(state), { passive: true });
    gallery.addEventListener('slideChanged', state);
    new MutationObserver(() => requestAnimationFrame(state)).observe(viewer, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden'] });
    state();
  });
});
